import React from 'react'
import { connect } from 'react-redux'
import FacilityOpenGameModal from '../components/facility-open-game-modal'

const mapStateToProps = (state) => ({
  ...state.facilityOpenGameModal
})

const mapDispatchToProps = dispatch => ({
  loadGame: payload => dispatch({type: 'FACILITY_OPEN_GAME_MODAL.LOAD_GAME', payload}),
  clearGame: payload => dispatch({type: 'FACILITY_OPEN_GAME_MODAL.CLEAR_GAME', payload}),
  showAlert: payload => dispatch({type: 'FACILITY_OPEN_GAME_MODAL.SHOW_ALERT', payload}),
  clearAlert: payload => dispatch({type: 'FACILITY_OPEN_GAME_MODAL.CLEAR_ALERT', payload}),
  onEditPlayerCost: payload => dispatch({type: 'FACILITY_OPEN_GAME_MODAL.EDIT_PLAYER_COST', payload}),
  onAddPlayer: payload => dispatch({type: 'FACILITY_OPEN_GAME_MODAL.ADD_PLAYER', payload}),
  onStartPayment: payload => dispatch({type: 'FACILITY_OPEN_GAME_MODAL.START_PAYMENT', payload}),
  onClearPayment: payload => dispatch({type: 'FACILITY_OPEN_GAME_MODAL.CLEAR_PAYMENT', payload}),
  onUpdateGame: payload => dispatch({type: 'FACILITY_OPEN_GAME_MODAL.UPDATE_GAME', payload}),
})

export default connect(mapStateToProps, mapDispatchToProps)(FacilityOpenGameModal)
